import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { findByKey } from "@erp/shared/utils/getProperty";
import { formatDate } from "@erp/shared/utils/date/formatted-date";
import { _estimateFilesInputs, _estimateSearchCompanyInfoInputs, estimateDefaultInfo, estimateDefaultInfo2, } from "../const";
/**
 * @description 견적서 기본 정보(견적서 정보) input 스토어
 *
 * [견적서 정보]
 * @param estimateSearchDefaultInfoInputs - 견적서 기본 정보
 *
 * [세부 정보]
 * @param input_issue_date - 발행일 input 데이터
 * @param input_inhouse_bid_number - 사내 견적번호 input 데이터
 * @param input_company_bid_number - 기업별 입찰번호 input 데이터
 * @param input_due_date - 납기 input 데이터
 * @param input_project_name - 프로젝트/용역 명 input 데이터
 * @param input_project_period - 프로젝트/용역 기간 input 데이터
 * @param input_remark - 특이사항 input 데이터
 *
 * @method setEstimateSearchInputs - 견적서 기본 정보 input 데이터 설정
 *
 * [업체 정보]
 * @param estimateBasicCompanyInfoData - 업체 정보 input 데이터
 *
 * [세부 업체 정보]
 * @param input_company_name - 업체명 input 데이터
 * @param input_company_manager - 담당자 input 데이터
 * @param input_company_manager_email - 담당자 E-mail input 데이터
 * @param input_company_manager_phone - 담당자 연락처 input 데이터
 *
 * @method setEstimateSearchCompanyInfoInputs - 업체 정보 input 데이터 설정
 *
 * [파일 정보]
 * @param estimateFilesInputs - 파일 정보 input 데이터
 *
 * [세부 파일 정보]
 * @param input_approval_file - 승인 파일 input 데이터
 * @param input_blueprint_file - 도면 파일 input 데이터
 * @param input_etc_file - 기타 파일 input 데이터
 *
 */
export const useEstimateBasicInfoStore = defineStore("estimateSearchDefaultInfoInputs", () => {
    const estimateBasicInfoData = ref(estimateDefaultInfo);
    const estimateBasicInfoData2 = ref(estimateDefaultInfo2);
    const estimateBasicCompanyInfoData = ref(_estimateSearchCompanyInfoInputs);
    const estimateFilesInputs = ref(_estimateFilesInputs);
    const input_issue_date = computed(() => findByKey(estimateBasicInfoData.value, "label", "발행일"));
    const input_inhouse_bid_number = computed(() => findByKey(estimateBasicInfoData.value, "label", "사내 견적번호"));
    const input_company_bid_number = computed(() => findByKey(estimateBasicInfoData.value, "label", "기업별 입찰번호"));
    const input_due_date = computed(() => findByKey(estimateBasicInfoData2.value, "label", "납기"));
    const input_project_name = computed(() => findByKey(estimateBasicInfoData2.value, "label", "견적명"));
    const input_project_period = computed(() => findByKey(estimateBasicInfoData2.value, "label", "견적 기간"));
    const input_remark = computed(() => findByKey(estimateBasicInfoData2.value, "label", "특이사항"));
    const input_company_name = computed(() => findByKey(estimateBasicCompanyInfoData.value, "label", "업체명"));
    const input_company_manager = computed(() => findByKey(estimateBasicCompanyInfoData.value, "label", "담당자"));
    const input_company_manager_email = computed(() => findByKey(estimateBasicCompanyInfoData.value, "label", "담당자 E-mail"));
    const input_company_manager_phone = computed(() => findByKey(estimateBasicCompanyInfoData.value, "label", "담당자 연락처"));
    const input_approval_file = computed(() => findByKey(estimateFilesInputs.value, "column_name", "approval") ?? null);
    const input_blueprint_file = computed(() => findByKey(estimateFilesInputs.value, "column_name", "blueprint") ??
        null);
    const input_etc_file = computed(() => findByKey(estimateFilesInputs.value, "column_name", "files") ?? null);
    const setEstimateSearchInputs = (item = null) => {
        if (!item)
            return;
        if (input_issue_date.value)
            input_issue_date.value.value = formatDate(item?.createdTime) ?? "";
        if (input_inhouse_bid_number.value)
            input_inhouse_bid_number.value.value = item?.inhouseBidNumber ?? "";
        if (input_company_bid_number.value)
            input_company_bid_number.value.value = item?.companyBidNumber ?? "";
        if (input_due_date.value) {
            input_due_date.value.value = formatDate(item?.dueDate) ?? "";
        }
        if (input_project_name.value) {
            input_project_name.value.value = item?.projectName ?? "";
        }
        if (input_project_period.value) {
            input_project_period.value.value = item?.projectPeriod ?? "";
        }
        if (input_remark.value) {
            input_remark.value.value = item?.remark ?? "";
        }
        if (input_company_name.value)
            input_company_name.value.value = item?.companyName ?? "";
        if (input_company_manager.value)
            input_company_manager.value.value = item?.managerName ?? "";
        if (input_company_manager_email.value)
            input_company_manager_email.value.value = item?.managerEmail ?? "";
        if (input_company_manager_phone.value)
            input_company_manager_phone.value.value = item?.managerPhone ?? "";
    };
    return {
        estimateBasicInfoData,
        estimateBasicInfoData2,
        input_issue_date,
        input_inhouse_bid_number,
        input_company_bid_number,
        input_due_date,
        input_project_name,
        input_project_period,
        input_remark,
        setEstimateSearchInputs,
        estimateBasicCompanyInfoData,
        input_company_name,
        input_company_manager,
        input_company_manager_email,
        input_company_manager_phone,
        estimateFilesInputs,
        input_approval_file,
        input_blueprint_file,
        input_etc_file,
    };
});
